module.exports = __webpack_public_path__ + "static/media/temusados-alpha.2acc875e.png";